import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	commentOn: {
		id: 'create-issue-from-comment.controllers.use-open-gic-from-comment.comment',
		defaultMessage: 'commented on',
		description: 'template message for description field of issue created via comment',
	},
});
